import { IconFontType } from './icon-font-type.enum';

/**
 * Provides icon font class names for use in the view
 */
export class ClassNames {
    /**
     * CSS class for the Fluent icons font
     */
    public static FluentIconCssClass = 'ms-ohp-Icon';

    /**
     * CSS class for SVG app Icons
     */
    public static SvgIconCssClass = 'ms-ohp-svg-Icon';

    /**
     * Mapping from an icon type name to its CSS class
     * Note: Any css class in this mapping is defined in AuthMDL2IconFont.css.
     *       Ensure that glyphs for ALL of the fonts defined here are added to the AuthMDL2IconFont.css
     */
    private static readonly iconTypeToCssClass: { [iconType: string]: string } = {
        'Accepted': 'ms-ohp-Icon--accepted',
        'Access': 'ms-ohp-Icon--accessLogo',
        'AccountActivity': 'ms-ohp-Icon--accountActivity',
        'Add': 'ms-ohp-Icon--add',
        'AddTo': 'ms-ohp-Icon--addTo',
        'Alert': 'ms-ohp-Icon--alert',
        'ArrowLeft': 'ms-ohp-Icon--back',
        'ArrowRight': 'ms-ohp-Icon--forward',
        'At': 'ms-ohp-Icon--accounts',
        'Attach': 'ms-ohp-Icon--attach',
        'Calendar': 'ms-ohp-Icon--calendar',
        'ContactCardSettings': 'ms-ohp-Icon--contactCardSettings',
        'Chat': 'ms-ohp-Icon--chatSolid',
        'CheckMark': 'ms-ohp-Icon--checkMark',
        'ChevronDown': 'ms-ohp-Icon--chevronDown',
        'ChevronLeft': 'ms-ohp-Icon--chevronLeft',
        'ChevronRight': 'ms-ohp-Icon--chevronRight',
        'ChevronUp': 'ms-ohp-Icon--chevronUp',
        'CircleFill': 'ms-ohp-Icon--circleFill',
        'CircleInfo': 'ms-ohp-Icon--circleInfo',
        'Comment': 'ms-ohp-Icon--chat',
        'Compass': 'ms-ohp-Icon--compassNW',
        'Copy': 'ms-ohp-Icon--copy',
        'Declined': 'ms-ohp-Icon--declined',
        'Delete': 'ms-ohp-Icon--delete',
        'Devices3': 'ms-ohp-Icon--devices3',
        'Diamond': 'ms-ohp-Icon--diamond',
        'Document': 'ms-ohp-Icon--page',
        'Download': 'ms-ohp-Icon--download',
        'Ellipsis': 'ms-ohp-Icon--moreVertical',
        'Excel': 'ms-ohp-Icon--excelLogo',
        'FavoriteStar': 'ms-ohp-Icon--favoriteStar',
        'Filter': 'ms-ohp-Icon--filter',
        'FilterSolid': 'ms-ohp-Icon--filterSolid',
        'Folder': 'ms-ohp-Icon--folder',
        'FolderOpen': 'ms-ohp-Icon--openFolderHorizontal',
        'GiftCard': 'ms-ohp-Icon--giftCard',
        'Glimmer': 'ms-ohp-Icon--glimmer',
        'Group': 'ms-ohp-Icon--group',
        'Hide': 'ms-ohp-Icon--hide',
        'HighLander': 'ms-ohp-Icon--highLanderLogo',
        'Home': 'ms-ohp-Icon--home',
        'Link': 'ms-ohp-Icon--link',
        'ListBullets': 'ms-ohp-Icon--list',
        'Location': 'ms-ohp-Icon--location',
        'Mail': 'ms-ohp-Icon--mail',
        'Minus': 'ms-ohp-Icon--remove',
        'Move': 'ms-ohp-Icon--moveToFolder',
        'News': 'ms-ohp-Icon--newsfeedLogo',
        'OfficeForms': 'ms-ohp-Icon--formsLogo',
        'Office': 'ms-ohp-Icon--officeLogo',
        'Office2': 'ms-ohp-Icon--officeLogo2',
        'OfficeStore': 'ms-ohp-Icon--officeStore',
        'OfficeThreshold': 'ms-Icon--officeThreshold', // TODO icon currently missing from font, but exists in the shell, so leaving as ms-Icon--officeThreshold for now.
        'OneDrive': 'ms-ohp-Icon--oneDriveLogo',
        'Outlook': 'ms-ohp-Icon--outlookLogo',
        'Onenote2': 'ms-ohp-Icon--onenoteLogo',
        'Page': 'ms-ohp-Icon--page',  // TODO when consumer moves to fluent icons, we need to add this one
        'Pencil': 'ms-ohp-Icon--edit',
        'PencilSolid': 'ms-ohp-Icon--editSolid',
        'People2': 'ms-ohp-Icon--people',
        'Permissions': 'ms-ohp-Icon--permissions',
        'Person': 'ms-ohp-Icon--person',
        'PhotoVideoMedia': 'ms-ohp-Icon--photoVideoMedia',
        'PinDown': 'ms-ohp-Icon--pinned',
        'PlayerSettings': 'ms-ohp-Icon--playerSettings',
        'PlaylistMusic': 'ms-ohp-Icon--playlistMusic',
        'PollResults': 'ms-ohp-Icon--pollResults',
        'PowerBI': 'ms-ohp-Icon--powerBILogo',
        'PowerPoint': 'ms-ohp-Icon--powerpointLogo',
        'Preview': 'ms-ohp-Icon--preview',
        'PreviewLink': 'ms-ohp-Icon--previewLink',
        'Project': 'ms-ohp-Icon--projectLogo',
        'Publisher': 'ms-ohp-Icon--publisherLogo',
        'Question': 'ms-ohp-Icon--question',
        'Restore': 'ms-ohp-Icon--revToggleKey',
        'Save': 'ms-ohp-Icon--save',
        'Search': 'ms-ohp-Icon--search',
        'Settings': 'ms-ohp-Icon--settings',
        'Share2': 'ms-ohp-Icon--share',
        'SharePoint': 'ms-ohp-Icon--sharepointLogo',
        'SkypeForBusiness': 'ms-ohp-Icon--skypeForBusinessLogo',
        'SortDown': 'ms-ohp-Icon--sortDown',
        'SortUp': 'ms-ohp-Icon--sortUp',
        'Stream': 'ms-ohp-Icon--streamLogo',
        'Sync': 'ms-ohp-Icon--sync',
        'System': 'ms-ohp-Icon--system',
        'Sway': 'ms-ohp-Icon--swayLogo',
        'Task': 'ms-ohp-Icon--tasksLogo',
        'Teams': 'ms-ohp-Icon--teamsLogo',
        'TentativelyAccepted': 'ms-ohp-Icon--tentativelyAccepted',
        'TextDocument': 'ms-ohp-Icon--textDocument',
        'ToDo': 'ms-ohp-Icon--toDoLogoInverse',
        'TileView': 'ms-ohp-Icon--viewAll',
        'Trending': 'ms-ohp-Icon--trending12',
        'Unfavorite': 'ms-ohp-Icon--unfavorite',
        'Unpin': 'ms-ohp-Icon--unpin',
        'Upload': 'ms-ohp-Icon--upload',
        'Video': 'ms-ohp-Icon--video',
        'Visio': 'ms-ohp-Icon--visioLogo',
        'Waffle': 'ms-ohp-Icon--waffle',
        'Word': 'ms-ohp-Icon--wordLogo',
        'X': 'ms-ohp-Icon--cancel',
        'X2': 'ms-ohp-Icon--cancel'  // TODO remove when fabric is gone
    };

    /**
     * Returns a CSS class name for the specified icon font type. If no CSS class
     * is found, returns the placeholder CSS class.
     * @param iconFontType The icon font type
     * @returns String with the corresponding CSS class name
     */
    public static getCssClass(iconFontType: IconFontType, useSvg?: boolean): string {
        const iconFontName = IconFontType[iconFontType];
        return ClassNames.getCssClassFromGlyphName(iconFontName, useSvg);
    }

    /**
     * Returns a CSS class name for the specified icon font name. If no CSS class
     * is found, returns the placeholder CSS class.
     * @param glyphName The icon font type
     * @returns String with the corresponding CSS class name
     */
    public static getCssClassFromGlyphName(glyphName: string, useSvg?: boolean): string {
        let cssClass = ClassNames.iconTypeToCssClass[glyphName];
        if (useSvg) {
            cssClass = `${cssClass} ${ClassNames.SvgIconCssClass}`;
        }

        return cssClass ? cssClass : 'ms-Icon--placeholder';
    }
}
